import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css"

const CustOutstandingForm = props => {
  return (
    <div class="col-md-12 text-center">
      <div className="col-md-3 p-2">
        <div className="col-md-6 p-0 pr-1 " style={{ zIndex: "1000" }}>
          <label>Date From</label>
          <Field
            inputType="date"
            inputName="fromDate"
            label="from Date"
            value={props.fromDate}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
        <div className="col-md-6 p-0" style={{ zIndex: "1000" }}>
          <label>Date To</label>
          <Field
            inputType="date"
            inputName="toDate"
            label="to Date"
            value={props.toDate}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
      </div>
      <div className="col-md-4 p-2" style={{ zIndex: "1000" }}>
        <label>Customer department</label>
        <App
          customerInfo={props.customerWithDepartment}
          selectedCustomers={props.storeCustomerData}
        />
      </div>
      <div className="col-md-5 p-1">
        <div className="col-md-4">
          <label>Source of request</label>
          <Field
            inputType="select"
            inputName="typeOfRequest"
            value={props.typeOfRequest}
            options={props.typeOfRequestOptions}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
        <div className="col-md-4">
          <label>Sample Type</label>
          {/* <Field
            inputType="select"
            inputName="sampleType"
            value={props.sampleType}
            options={props.sampleTypeOptions}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          /> */}
          <Picky
            value={props.arrayValue}
            options={props.sampleTypeOptions}
            onChange={props.selectMultipleOption1}
            open={false}
            valueKey="value"
            labelKey="label"
            multiple={true}
            includeSelectAll={true}
            manySelectedPlaceholder={"%s selected"} 
            allSelectedPlaceholder={"%s selected"}
            includeFilter={true} 
            dropdownHeight={300}
            placeholder="Select a sample type" 
            disabled={false}
          />
        </div>
        <div className="col-md-4">
          <label>Need Image</label>
          <Field
            inputType="select"
            inputName="image"
            value={props.image}
            options={[
              { label: "YES", value: true },
              { label: "NO", value: false }
            ]}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
      </div>
      <div className="col-md-12 text-center d-flex justify-content-center">
        <div className="col-md-2" style={{ zIndex: "1000" }}>
          <label>Created On</label>
          <Field
            inputType="date"
            inputName="createdAt"
            label="createdAt"
            value={props.createdAt}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
      </div>
    </div>

  );
};

export default CustOutstandingForm;


// WEBPACK FOOTER //
// ./src/components/Report/forms/CustOutstandingForm.js